import { assertPackageVersion } from '@dynamic-labs-sdk/assert-package-version';

import {
  name as packageName,
  version as packageVersion,
} from '../../package.json';
assertPackageVersion(packageName, packageVersion);

export { addEvmExtension } from '../addEvmExtension';
export { RpcError } from '../errors/RpcError';
export type { EvmNetworkProvider } from '../EvmNetworkProvider';
export type { EvmWalletAccount } from '../EvmWalletAccount.types';
export type { EvmWalletProvider } from '../EvmWalletProvider.types';
export { isEvmNetworkProvider } from '../isEvmNetworkProvider';
export { simulateEvmTransaction } from '../simulateEvmTransaction';
export type {
  EvmSimulationResult,
  EvmTransactionFeeData,
  EvmTransactionToSimulate,
} from '../transactionSimulation.types';
export { calculateEvmTransactionFee } from '../utils/calculateEvmTransactionFee';
export { isEvmWalletAccount } from '../utils/isEvmWalletAccount';
